import React from "react";
import Accordions from "../../../components/Accordions";

const Sem5Eece1 = () =>{
  const data = [
    // {
    //   subjectName: "2023 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2024-Batch/EXE-1-5-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EXE Sem - 5</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem5Eece1;
